import React from 'react';

const MeetYourNewTeamIcon = (props) => (
  <svg width='240' height='211' viewBox='0 0 240 211' {...props}>
    <g fill='currentColor'>
      <path
        d='M11.803 71.603.01 65.093A42.094 42.094 0 0 1 4.608 45c2.718 12.094 17.026 17.848 23.627 28.408a25.295 25.295 0 0 1 2.132 22.215l.776 9.377C18.809 101.38 8.71 92.647 3.51 81.103A41.038 41.038 0 0 1 .56 71.057c5.499.574 11.243.546 11.243.546zM220.418 191.282l.36-8.168A26.063 26.063 0 0 1 233 180c-5.87 4.831-5.136 14.144-9.116 20.64a15.75 15.75 0 0 1-11.557 7.332L207.415 211a26.717 26.717 0 0 1 5.567-21.544 25.578 25.578 0 0 1 4.688-4.385c1.176 3.122 2.748 6.21 2.748 6.21z'
        fill='#F2F2F2'
        fillRule='nonzero'
      />
      <path fill='#FFB6B6' fillRule='nonzero' d='M208 207h-4.066L202 190h6z' />
      <path
        d='M209 211h-14v-.188c0-3.181 2.44-5.76 5.45-5.76l2.557-2.052 4.77 2.051H209V211z'
        fill='#2F2E41'
        fillRule='nonzero'
      />
      <path fill='#FFB6B6' fillRule='nonzero' d='M187.999 207h-4.065L182 190h6z' />
      <path
        d='M189 211h-15v-.188c0-3.181 2.614-5.76 5.838-5.76l2.74-2.052 5.113 2.051H189V211zM185.045 114l28.244.72c5.365 2.974 5.446 9.408 3.688 17.048 0 0 .594 4.54-.593 5.752-1.187 1.21-1.78 1.21-1.187 3.33.594 2.119-2.541 5.58-2.16 5.968.38.389 1.27 2.508 1.27 2.508l-2.966 17.255s-2.077 29.97-2.67 30.575c-.594.606-1.187 0-.594 1.514.594 1.514 1.187.908.594 1.514a22.199 22.199 0 0 0-1.484 1.816h-7.172s-.54-3.027-.54-3.33c0-.303-.594-2.119-.594-2.422 0-.302.524-.838.524-.838a10.14 10.14 0 0 0 .366-1.886c0-.606 1.78-23.915 1.78-23.915l-3.56-30.273-8.604 29.667s0 26.034-.593 26.64c-.593.605-.593.303-.297 1.513.297 1.211 1.484.909.594 1.817-.89.908-1.187-.606-.89.908l.296 1.514-8.9.13s-1.186-2.552-.593-3.46c.593-.909.558-.66-.166-2.147-.724-1.486-1.02-1.789-.724-2.092.297-.302.297-1.912.297-1.912l1.483-28.965s.297-30.576.297-31.484a3.074 3.074 0 0 0-.247-1.362v-1.232l1.137-4.368L185.045 114z'
        fill='#2F2E41'
        fillRule='nonzero'
      />
      <circle fill='#FFB6B6' fillRule='nonzero' cx='203' cy='46' r='9' />
      <path
        d='M199.258 60.278c-1.923 1.127-3.073 3.199-3.733 5.306a49.667 49.667 0 0 0-2.191 12.015l-.698 12.208L184 115.8c7.485 6.247 35.62 1.42 35.62 1.42s.863-.284 0-1.136c-.864-.852-1.705-.097-.841-.949.863-.852.268.097-.02-.755-.288-.851 0-.284.288-.567.288-.284-2.229-2.84-2.229-2.84l2.303-14.92L222 65.956c-3.455-4.26-10.402-6.77-10.402-6.77L209.803 56l-8.976.708-1.57 3.57z'
        fill='#E6E6E6'
        fillRule='nonzero'
      />
      <path
        d='M197.204 40.54a4.12 4.12 0 0 1 1.018.137c.655.16 1.321.274 1.992.34 4.23.406 7.642 3.7 8.268 7.983.516-.458 1.69-1.302 2.652-.518.015.012.024.019.057.002.64-.308 1.774-4.111 1.808-7.46.018-1.777-.256-4.047-1.666-4.765l-.075-.038-.02-.082c-.093-.4-1.146-1.083-2.976-1.614-3.324-.965-8.28-2.845-11.071-.078-.212.933-.899 2.93-1.593 3.155-.768.25-1.432.467-1.537 1.428a30.02 30.02 0 0 0 .02 4.106 4.193 4.193 0 0 1 1.46-2.092 2.858 2.858 0 0 1 1.663-.504z'
        fill='#2F2E41'
        fillRule='nonzero'
      />
      <path
        d='M180.59 90 195 80.711 187.742 71l-7.166 8.873-22.329 1.379a4.236 4.236 0 0 0-5.93-.053 4.304 4.304 0 0 0-.224 5.965 4.236 4.236 0 0 0 5.916.4L180.59 90z'
        fill='#FFB6B6'
        fillRule='nonzero'
      />
      <path
        d='M208.969 67.539c.816 5.029-14.6 14.633-14.6 14.633 0-1.18-9.202 7.732-9.617 6.753-1.18-2.783-2.01-9.374-3.66-10.428-.943-.604 5.681-6.271 5.681-6.271s3.468-3.556 8.018-8.042c2.568-2.627 6.279-3.73 9.832-2.925 0 0 3.53 1.25 4.346 6.28z'
        fill='#E6E6E6'
        fillRule='nonzero'
      />
      <path
        d='M238 92.238 228.48 78 219 85.475l8.954 6.991 1.84 22.338a4.273 4.273 0 0 0 .073 5.94 4.24 4.24 0 0 0 5.922.1 4.273 4.273 0 0 0 .272-5.935L238 92.24z'
        fill='#FFB6B6'
        fillRule='nonzero'
      />
      <path
        d='M216.312 65.04c4.945-.928 14.75 14.407 14.75 14.407-1.165.025 7.824 9.11 6.866 9.55-2.72 1.248-9.205 2.222-10.21 3.906-.576.964-6.309-5.593-6.309-5.593s-3.582-3.42-8.105-7.912a10.722 10.722 0 0 1-3.096-9.846s1.16-3.583 6.104-4.512z'
        fill='#E6E6E6'
        fillRule='nonzero'
      />
      <path
        d='M240 210.5c0 .133-.044.26-.123.354a.39.39 0 0 1-.298.146h-99.158c-.233 0-.421-.224-.421-.5s.188-.5.421-.5h99.158a.39.39 0 0 1 .298.146.552.552 0 0 1 .123.354z'
        fill='#CCC'
        fillRule='nonzero'
      />
      <path
        d='M147.883 82H27.117c-3.929.004-7.113 3.209-7.117 7.163v75.674c.004 3.954 3.188 7.159 7.117 7.163h120.766c3.929-.004 7.113-3.209 7.117-7.163V89.163c-.004-3.954-3.188-7.159-7.117-7.163z'
        fill='#6C63FF'
        fillRule='nonzero'
      />
      <path
        d='M147.883 82H27.117c-3.929.004-7.113 3.209-7.117 7.163v75.674c.004 3.954 3.188 7.159 7.117 7.163h120.766c3.929-.004 7.113-3.209 7.117-7.163V89.163c-.004-3.954-3.188-7.159-7.117-7.163zm2.336 54.358c-.06 16.025-12.843 29.06-28.763 29.33-12.254.16 6.78.223-8 .223-33.795 0-69.034-.325-82.182-.536-3.597-.075-6.479-3.024-6.493-6.645V89.168a2.351 2.351 0 0 1 2.335-2.356h120.762a2.35 2.35 0 0 1 2.34 2.35v47.196z'
        fill='#3F3D56'
        fillRule='nonzero'
      />
      <path
        d='M133.76 38H41.254c-1.676.002-3.172 1.073-3.737 2.677L23.23 81.393a4.084 4.084 0 0 0 .494 3.673 3.95 3.95 0 0 0 3.238 1.71L151.027 87h.005c1.334 0 2.579-.68 3.313-1.812a4.085 4.085 0 0 0 .334-3.806l-.216.094.216-.094-17.272-40.94A3.962 3.962 0 0 0 133.76 38z'
        fill='#3F3D56'
        fillRule='nonzero'
      />
      <path
        d='M155 81.973c0 .538-.11 1.07-.321 1.565l-17.272 31.057A3.979 3.979 0 0 1 133.76 117H41.255a3.979 3.979 0 0 1-3.74-2.637L23.23 83.528a3.973 3.973 0 0 1 3.73-5.306l15.154-.03 6.186-.01 81.393-.143 6.19-.01L151.026 78h.004A3.971 3.971 0 0 1 155 81.973zM36.393 138C38.267 138 64 139.622 64 141.555S38.267 145 36.393 145c-1.874 0-3.393-1.567-3.393-3.5s1.52-3.5 3.393-3.5z'
        fill='#3F3D56'
        fillRule='nonzero'
      />
      <path
        d='M128.096 14H49.904c-4.363.005-7.899 3.534-7.904 7.888V117h91.871a3.934 3.934 0 0 0 2.129-.618V21.888c-.005-4.354-3.54-7.883-7.904-7.888z'
        fill='#E6E6E6'
        fillRule='nonzero'
      />
      <path
        d='M98.685 20H56.147c-3.944.004-7.141 3.23-7.147 7.21V117h81V51.61c-.02-17.45-14.028-31.59-31.315-31.61z'
        fill='#FFF'
        fillRule='nonzero'
      />
      <path
        d='M115.256 109H61.744c-.963 0-1.744.895-1.744 2s.78 2 1.744 2h53.512c.963 0 1.744-.895 1.744-2s-.78-2-1.744-2zM115.254 102H61.746c-.964 0-1.746.895-1.746 2s.782 2 1.746 2h53.508c.964 0 1.746-.895 1.746-2s-.782-2-1.746-2zM84.235 95h-23.47C59.79 95 59 95.895 59 97s.79 2 1.765 2h23.47C85.21 99 86 98.105 86 97s-.79-2-1.765-2zM115.254 80H61.746c-.964 0-1.746.895-1.746 2s.782 2 1.746 2h53.508c.964 0 1.746-.895 1.746-2s-.782-2-1.746-2zM115.256 74H61.744c-.963 0-1.744.895-1.744 2s.78 2 1.744 2h53.512c.963 0 1.744-.895 1.744-2s-.78-2-1.744-2zM84.234 67H60.766c-.975 0-1.766.895-1.766 2s.79 2 1.766 2h23.468c.975 0 1.766-.895 1.766-2s-.79-2-1.766-2z'
        fill='#E4E4E4'
        fillRule='nonzero'
      />
      <path
        d='M115.254 52H61.746c-.964 0-1.746.895-1.746 2s.782 2 1.746 2h53.508c.964 0 1.746-.895 1.746-2s-.782-2-1.746-2zM115.254 45H61.746c-.964 0-1.746.895-1.746 2s.782 2 1.746 2h53.508c.964 0 1.746-.895 1.746-2s-.782-2-1.746-2zM84.234 38H60.766c-.975 0-1.766.895-1.766 2s.79 2 1.766 2h23.468c.975 0 1.766-.895 1.766-2s-.79-2-1.766-2z'
        fill='#6C63FF'
        fillRule='nonzero'
      />
      <circle fill='#6C63FF' cx='131.5' cy='13.5' r='13.5' />
      <path
        d='M131.737 4c.932 0 1.692.695 1.735 1.568l.002.077v8.24l6.726 4.085c.783.475 1.028 1.446.57 2.202l-.045.07c-.502.742-1.527.974-2.325.54l-.074-.042L130 15.684V5.645c0-.908.778-1.645 1.737-1.645z'
        fill='#FFF'
        fillRule='nonzero'
      />
    </g>
  </svg>
);

export default MeetYourNewTeamIcon;
